import rolecatalogAPI from "../../api/rolecatalogAPI";
import { urlContexts } from "../../constants";

  export const getFunctionalities = async () => {
    const { data } = await rolecatalogAPI.get(
      `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/functionality`
    );
  
    return data;
  };
  
  export const createFunctionalities = async (createInfo: any) => {
    const { data } = await rolecatalogAPI.post(
      `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/functionality`,
      createInfo
    );
  
    return data;
  };
  
  export const updateFunctionalities = async (updateInfo: any) => {
    const { data } = await rolecatalogAPI.put(
      `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/functionality/${updateInfo?.code}`,
      {
        ...updateInfo,
        id: undefined,
      }
    );
  
    return data;
  };
  
  export const deleteFunctionalities = async (deleteInfo: any) => {
    const { data } = await rolecatalogAPI.delete(
      `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/functionality/${deleteInfo?.code}`
    );
  
    return data;
  };
  
  export const reactiveFunctionalities = async (reactiveInfo: any) => {
    const { data } = await rolecatalogAPI.put(
      `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/functionality/${reactiveInfo?.code}/reactivate`
    );
  
    return data;
  };
